<template>
    <div class="selectCustomer-box">
        <HeaderNav
            header-title="选择附加型号"
            left-icon-name="3"
            right-icon-name="3"
        ></HeaderNav>
        <div class="newPlan" @click="sureSelect">
            <span class="text-info">确定</span>
        </div>
        <span class="back iconfont" @click="handleBack">&#xe607;</span>
        <!-- <div class="search-con">
            <van-search placeholder="请输入搜索关键词"></van-search>
        </div> -->
        <div class="project-list">
            <!-- <van-cell-group>
                <van-cell
                    title="全选"
                    clickable
                >
                    <template #right-icon>
                        <van-checkbox v-model="allCheck" @change="checkAll" ref="allCheckboxes"></van-checkbox>
                    </template>
                </van-cell>
            </van-cell-group> -->
            <van-checkbox-group v-model="result" @change="changeCheckbox">
                <van-cell-group ref="checkboxGroup">
                    <van-cell
                        v-for="(item, index) in specialRequireList"
                        clickable
                        :key="item.additional_model_code"
                        :title="item.additional_model"
                        @click="toggle(index)"
                    >
                        <template #right-icon>
                            <van-checkbox :name="item.additional_model_code" ref="checkboxes"></van-checkbox>
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-checkbox-group>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import { Toast } from 'vant';
export default {
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            formData: {},
            specialRequireList: [],
            result: [],
            resultName: [],
            allCheck: false,
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 返回
        handleBack() {
            if (this.result.length > 0) {
                this.parseSelectData();
            }
            this.$router.isBack = 1;
            this.$router.replace({ name: 'newRetailAccount',
                params: { formData: this.formData, type: this.$route.params.handleType, actionType: 'selededAdditional' },
            });
            this.$router.go(-1);

        },
        // 全选
        checkAll(checked) {
            if (checked) {
                this.specialRequireList.map(item => {
                    this.result.push(item.additional_model_code);
                    this.resultName.push(item.additional_model);
                });
            } else {
                this.result = [];
                this.resultName = [];
            }
        },
        // 选择
        changeCheckbox(names) {
            this.result = names;
            this.resultName = [];
            this.specialRequireList.map(item => {
                this.result.map(v => {
                    if (item.additional_model_code === v) {
                        this.resultName.push(item.additional_model);
                    }
                });
            });
        },
        // 点击行切换
        toggle(index) {
            this.$refs.checkboxes[index].toggle();
        },
        // 确定选择
        sureSelect() {
            if (this.result.length > 0) {
                this.parseSelectData();
                this.handleChooseEvent();
            }
            this.$router.isBack = 1;
            this.$router.replace({ name: 'newRetailAccount',
                params: { formData: this.formData, handleType: this.$route.params.handleType, actionType: 'selededAdditional' },
            });
            this.$router.go(-1);
        },
        // 处理选择后的数据
        parseSelectData() {
            this.formData.additional_model = this.result.join('|');
            this.formData.additional_model_name = this.resultName.join(',');
            // let price = 0;
            // this.specialRequireList.map(item => {
            //     this.result.map(v => {
            //         if (item.additional_model_code === v) {
            //             if (item.additional_model_price) {
            //                 price += item.additional_model_price;
            //             }
            //         }
            //     });
            // });
            // this.formData.price = price;
        },
        // 附加型号-拉取字典
        getAdditionalByDictionary() {
            this.$axios.post('/interfaceApi/sale/contract_price/get_additional_list').then(res => {
                if (res) {
                    res.map( item => {
                        this.specialRequireList.push(
                            { additional_model_code: item.smallclass_code, additional_model: item.smallclass_name, bigclass_code: item.bigclass_code }
                        );
                    });
                }
            }).catch(error => {
                this.$toast(error.ErrorCode.Message);
            });
        },
        // 确认选择附加型号触发
        handleChooseEvent() {
            const selectData = this.specialRequireList.filter(item => this.result.indexOf(item.additional_model_code) !== -1);
            if (selectData.length > 0) {
                const code501 = [];
                const codeF502 = [];
                selectData.forEach(item => {
                    if (item.bigclass_code === '501') {
                        code501.push(item.additional_model_code);
                    } else if (item.bigclass_code === 'F5-02') {
                        codeF502.push(item.additional_model_code);
                    }
                });
                if (code501.length > 0) {
                    this.$axios.put('/interfaceApi/BaseInfo/dictionary_config/modify_user_count?code=' + code501.join());
                }
                if (codeF502.length > 0) {
                    this.$axios.put('/interfaceApi/BaseInfo/businessgroup_config/modify_user_count?code=' + codeF502.join());
                }
            }
        },
    },
    created() {
        this.formData = this.$route.params.formData;
        this.getAdditionalByDictionary();
    },
    mounted() {
    },
};
</script>
<style lang="stylus" scoped>
.selectCustomer-box
    padding-top 44rpx
    height calc(100% - 44rpx)
    .newPlan
        position fixed
        right 20rpx
        top 12rpx
        z-index 1000
        color #fff
        .text-info
            color #fff
            font-size 14rpx
    .back
        position absolute
        top 10rpx
        left 15rpx
        z-index 10000
        color #fff
    .search-con
        .van-search
            background #F0F0F0!important
    .project-list
        height 100%
        overflow-y auto
        overflow-x hidden
        background #fff
        li
            height 46rpx
            line-height 46rpx
            padding 0 10rpx
            border-bottom 1px solid #F0F0F0
</style>
<style>
    .selectCustomer-box .van-cell:not(:last-child)::after{
        left: 0;
    }
</style>
